// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"ac5d88d3","351":"2a379e1d","574":"ad9efd20","605":"2a379e1d","866":"ed147b55"}[chunkId] + ".css";
};